import { render } from "./Companies.vue?vue&type=template&id=4ae9876c&scoped=true&ts=true"
import script from "./Companies.vue?vue&type=script&lang=ts"
export * from "./Companies.vue?vue&type=script&lang=ts"

import "./Companies.vue?vue&type=style&index=0&id=4ae9876c&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae9876c"]])

export default __exports__